import EPSG_28350 from 'epsg-index/s/28350.json'
import EPSG_28351 from 'epsg-index/s/28351.json'
import EPSG_28352 from 'epsg-index/s/28352.json'
import EPSG_28353 from 'epsg-index/s/28353.json'
import EPSG_28354 from 'epsg-index/s/28354.json'
import EPSG_28355 from 'epsg-index/s/28355.json'
import EPSG_28356 from 'epsg-index/s/28356.json'
import EPSG_3111 from 'epsg-index/s/3111.json'
import EPSG_4283 from 'epsg-index/s/4283.json'
import EPSG_4326 from 'epsg-index/s/4326.json'
import EPSG_7844 from 'epsg-index/s/7844.json'
import EPSG_7850 from 'epsg-index/s/7850.json'
import EPSG_7851 from 'epsg-index/s/7851.json'
import EPSG_7852 from 'epsg-index/s/7852.json'
import EPSG_7853 from 'epsg-index/s/7853.json'
import EPSG_7854 from 'epsg-index/s/7854.json'
import EPSG_7855 from 'epsg-index/s/7855.json'
import EPSG_7856 from 'epsg-index/s/7856.json'
import EPSG_7899 from 'epsg-index/s/7899.json'
import { addEquivalentProjections, get as olProjGet } from 'ol/proj'
import { register } from 'ol/proj/proj4'
import proj4 from 'proj4'

/*
  WGS84 - EPSG:4326
  GDA2020 - EPSG:7844
  GDA2020 / MGA Zone 50 - EPSG:7850
  GDA2020 / MGA Zone 51 - EPSG:7851
  GDA2020 / MGA Zone 52 - EPSG:7852
  GDA2020 / MGA Zone 53 - EPSG:7853
  GDA2020 / MGA Zone 54 - EPSG:7854
  GDA2020 / MGA Zone 55 - EPSG:7855
  GDA2020 / MGA Zone 56 - EPSG:7856
  GDA2020 / Vicgrid - EPSG:7899
  GDA94 / MGA Zone 50 - EPSG:28350
  GDA94 / MGA Zone 51 - EPSG:28351
  GDA94 / MGA Zone 52 - EPSG:28352
  GDA94 / MGA Zone 53 - EPSG:28353
  GDA94 / MGA Zone 54 - EPSG:28354
  GDA94 / MGA Zone 55 - EPSG:28355
  GDA94 / MGA Zone 56 - EPSG:28356
  GDA94 / Vicgrid - EPSG:3111
*/

const projections = [
  EPSG_28350,
  EPSG_28351,
  EPSG_28352,
  EPSG_28353,
  EPSG_28354,
  EPSG_28355,
  EPSG_28356,
  EPSG_3111,
  EPSG_4283,
  EPSG_4326,
  EPSG_7844,
  EPSG_7850,
  EPSG_7851,
  EPSG_7852,
  EPSG_7853,
  EPSG_7854,
  EPSG_7855,
  EPSG_7856,
  EPSG_7899
]

const defaultProjectionCode = 'EPSG:4326'
const supportedProjections = {}
const supportedProjectionsArr = []

// Register supported projections with proj4. We do this for both EPSG:XXXXX as
// well as for http://www.opengis.net/.... as the latter is required to make things
// work with GeoServer
projections.forEach(proj => {
  const { code: proj4Code, proj4: proj4Value } = proj || {}

  if (proj4Code && proj4Value) {
    const epsgId = `EPSG:${proj.code}`
    const opengisId = `http://www.opengis.net/gml/srs/epsg.xml#${proj.code}`

    // Register in Proj4
    proj4.defs(epsgId, proj4Value)
    proj4.defs(opengisId, proj4Value)

    // And keep track for our own purposes
    supportedProjections[epsgId] = proj
    supportedProjectionsArr.push(epsgId)
  } else {
    console.log('ProjUtils - Invalid projection:', proj)
  }
})

// Needed for use in OpenLayers
register(proj4)

// Register projections as equivalent
// See: https://github.com/openlayers/openlayers/issues/3898
projections.forEach(proj => {
  const epsgId = `EPSG:${proj.code}`
  const opengisId = `http://www.opengis.net/gml/srs/epsg.xml#${proj.code}`

  // console.debug('ProjUtils - equivalent', epsgId, opengisId)

  addEquivalentProjections([
    olProjGet(epsgId),
    olProjGet(opengisId)
  ])
})

// console.debug('ProjUtils - supported projections', supportedProjections)

export {
  defaultProjectionCode,
  proj4,
  supportedProjections,
  supportedProjectionsArr
}
